import HttpClient from "libs/utils/HttpClient";

class SmartCompanyService {
  async getSmartCompany(SmartCompanyID) {
    try {
      const response = await HttpClient.get(
        `/api/visaform/smartcompany/list?SmartCompanyID=${SmartCompanyID}`
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async addSmartCompany(body) {
    try {
      const response = await HttpClient.post(
        `/api/visaform/smartcompany/add`,
        body
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async addSmartCompanyShareholder(body) {
    try {
      const response = await HttpClient.post(
        `/api/visaform/smartcompanyshareholder/add`,
        body
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async uploadSmartCompanyDoc(body) {
    try {
      const response = await HttpClient.post(
        `/api/visaform/smartcompanydocumentreq/add`,
        body
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  async updateSmartCompanyConditionType(body) {
    try {
      const response = await HttpClient.post(
        `/api/visaform/smartcompanyconditiontype/update`,
        body
      );
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }
}

export default new SmartCompanyService();
